// Общие константы для форсунок

export const NOZZLE_AXIS = {
    LENGTH: 'length',
    WIDTH: 'width',
    BOTTOM: 'bottom'
};

export const NOZZLE_TYPE = {
    WALL: 'wall',
    BOTTOM: 'bottom',
    VACUUM: 'vacuum'
};

// Константы для raycasting и взаимодействия
export const RAYCASTING = {
    BOTTOM_CLICK_THRESHOLD: -0.5,
    AMBIGUOUS_CLICK_THRESHOLD: 0.2,
    HEIGHT_DIFFERENCE_LIMIT: 0.3,
    BOTTOM_HEIGHT_THRESHOLD: -0.3,
    SEARCH_RADIUS: 0.5
};

export const NOZZLE_CONSTANTS = {
    TOOLTIP: {
        x: 0,
        y: 0.9,
        BOTTOM_Y: 0.9,
        z: 0
    },
    CLICK_AREA: {
        BOX_GEOMETRY: [3, 3, 2]
    }
};
